import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";

const Goto_cart_card = ({ selectedVariant, product, show, handleClose }) => {
  const navigate = useNavigate();
  const { IMG_URL, signin, triggerCartUpdate, setTaxRupees, taxRupees } =
    useContext(Context);

  console.log(selectedVariant, "selectedVariant selectedVariant");

  return (
    <>
      <div className="GotoCart_container">
        <div className="goto_cart_card">
          <div className="left_side">
            <div className="img_holder">
              <img
                src={IMG_URL + selectedVariant?.product_images[0]?.image}
                alt="Product"
              />
            </div>

            <div className="text_holder">
              <h6>1 Item | ₹ {selectedVariant?.s_price}</h6>
              <p>
                You saved ₹ {selectedVariant?.mrp - selectedVariant?.s_price}
              </p>
            </div>
          </div>

          <div className="btn_holder">
            <Blue_Btn
              btn_name="Go To Cart"
              onClick={() => navigate("/product-cart")}
            />

            <div className="close_div" onClick={handleClose}>
              <FontAwesomeIcon icon={faXmark} className="close_icon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Goto_cart_card;
